// extracted by mini-css-extract-plugin
export var aiStarIcon = "_kq-2";
export var container = "_kq-4";
export var dismissButton = "_kq-3";
export var hasPaddingBottom = "_kq-6";
export var last = "_kq-e";
export var scrollbarThumb = "_kq-c";
export var scrollbarTrack = "_kq-b";
export var selected = "_kq-9";
export var spin = "_kq-1";
export var spinning = "_kq-0";
export var suggestionItem = "_kq-d";
export var suggestionsPanel = "_kq-5";
export var tonePill = "_kq-8";
export var tonesContainer = "_kq-7";
export var unselected = "_kq-a";